// extracted by mini-css-extract-plugin
module.exports = {"menuSub":"Menus_menuSub__AnX3r","optionName":"Menus_optionName__CJIhV"};